import { IProfileState } from './profile/types';
import { IGamesState } from './games/types';

export interface IRootState {
  version: string;
  showSuccessSnackbar: boolean;
  showErrorSnackbar: boolean;
  createWalletPrompt: {
    show: boolean;
    walletType: string;
  };
  showDiscordDialog: boolean;
  showDiscordConnectingDialog: boolean;
  showGyriExchangeRewardsModal: boolean;
  showReferralDialog: boolean;
  snackbarErrorText: string;
  snackbarSuccessText: string;
  currentPage: ICurrentPage;
  previousPage: IPreviousPage;
  profile?: IProfileState;
  games?: IGamesState;
  showSettingsPage: string;
  discordLink: string;
  userAgentInfo: IUserAgentInfo;
  apiErrorCodes: Array<{ id: string; timestamp: string }>;
  showResetDialog: boolean;
  tokenMigrationStatus: TokenMigrationStatus;
  legalDocumentSuppressors: string[];
}

export enum TokenMigrationStatus {
  inactive = 1,
  locking,
  ready,
  active,
  complete,
  verified,
}

export interface IUserAgentInfo {
  language: string;
  displayMode: string;
  ip?: string;
}

export interface ICurrentPage {
  title: string;
  showBoxCoinBalance?: boolean;
  backIcon?: string;
  backRoute?: string;
  forceBackRoute?: boolean;
}
export interface IPreviousPage {
  path: string;
  sameAsCurrent: boolean;
}

export interface ISortOption {
  title: string;
  property: string;
  direction: number;
  value?: any;
  displayTitle?: string;
}

export interface IBaseResponse {
  success: boolean | number;
  message?: string;
}
export type IBaseGqlResponse<K extends string, T = {}> = {
  [k in K]: IBaseResponse & T;
};
